import SaveProfileEmailDto from '../../dto/profiles/in/save-profile-email.dto';
import { apiV1 } from '../../http';
import { axiosHttpErrorToError } from '../../utils/errors';

class SaveProfileEmailService {
  async save(id: string, dto: SaveProfileEmailDto): Promise<void> {
    try {
      await apiV1.put<void>(`/profiles/${id}/email`, dto);
    } catch (error) {
      throw axiosHttpErrorToError(error);
    }
  }
}

export default SaveProfileEmailService;
